const jwtCookieKey = "accelerate.jwt";
const customerCookieKey = "customerid";

function getCookie(key: string): string | undefined {
  const matches = document.cookie.match(`(^|;)\\s*${key}\\s*=\\s*([^;]+)`);

  return matches ? matches.pop() : undefined;
}

function setCookie(name: string, value: string, minutes: number) {
  const expiration = new Date();
  expiration.setTime(expiration.getTime() + minutes * 60 * 1000);
  const expires = `expires=${expiration.toUTCString()}`;

  document.cookie = `${name}=${value}; ${expires}; path=/`;
}

function eraseCookie(name: string, includeDomain: boolean = true) {
  const domain = includeDomain
    ? `domain=${process.env.AUTHCHECK_COOKIE_DOMAIN};`
    : "";
  document.cookie = `${name}=; Path=/; ${domain} Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
}

function eraseChemCookie(name: string) {
  document.cookie = `${name}=; Path=/; domain=${process.env.CHEM_MANAGEMENT_COOKIE_DOMAIN}; Expires=Thu, 01 Jan 1970 00:00:01 GMT; secure; SameSite=None;`;
}

function getJwt() {
  return getCookie(jwtCookieKey) || "";
}

function getCustomerCookie() {
  return getCookie(customerCookieKey) || "";
}

function setCustomerCookie(customerId: string) {
  setCookie(customerCookieKey, customerId, 120);
}

function eraseCookies() {
  eraseCookie(customerCookieKey, false);
}

function eraseChemCookies() {
  eraseChemCookie(
    `chem_${process.env.CHEM_MANAGMENT_COOKIE_ENV_NAME}_UserLoggedIn`
  );
  eraseChemCookie(
    `chem_${process.env.CHEM_MANAGMENT_COOKIE_ENV_NAME}_AuthCookie`
  );
}

export {
  getCookie,
  setCookie,
  eraseCookie,
  getJwt,
  eraseCookies,
  setCustomerCookie,
  getCustomerCookie,
  eraseChemCookies,
};
